module.exports = "<!-- <app-logout></app-logout> -->\n<router-outlet></router-outlet>\n"